import React from 'react';

interface MenuButtonProps {
  isOpen: boolean;
  onClick: () => void;
  className?: string;
}

export default function MenuButton({ isOpen, onClick, className = '' }: MenuButtonProps) {
  return (
    <button
      onClick={onClick}
      className={`flex items-center justify-center rounded-md bg-transparent focus:outline-none ${className}`}
      aria-label={isOpen ? "Close menu" : "Open menu"}
    >
      <div className="relative w-4 h-4 flex items-center justify-center">
        <div className={`absolute inset-0 flex flex-col justify-center space-y-1 transition-all duration-200 ${isOpen ? 'opacity-0 scale-90' : 'opacity-100 scale-100'}`}>
          <span className="h-0.5 w-4 bg-gray-600 dark:bg-gray-300 rounded-full transform origin-center transition-all duration-200"></span>
          <span className="h-0.5 w-3 bg-gray-600 dark:bg-gray-300 rounded-full transform origin-center transition-all duration-200"></span>
          <span className="h-0.5 w-4 bg-gray-600 dark:bg-gray-300 rounded-full transform origin-center transition-all duration-200"></span>
        </div>
        
        <div className={`absolute inset-0 flex items-center justify-center transition-all duration-200 ${isOpen ? 'opacity-100 scale-100' : 'opacity-0 scale-90'}`}>
          <span className="h-0.5 w-4 bg-gray-600 dark:bg-gray-300 rounded-full transform rotate-45 absolute"></span>
          <span className="h-0.5 w-4 bg-gray-600 dark:bg-gray-300 rounded-full transform -rotate-45 absolute"></span>
        </div>
      </div>
    </button>
  );
}